import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// #region styled-components
const StyledButton = styled.button`
  all: initial;

  position: relative;
  color: ${(props) =>
    props.active
      ? 'var(--cc_color_link_primary)'
      : 'var(--cc_color_link_subtle)'};
  font-family: 'Averta', system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: var(--cc_size_text_m);
  font-weight: 600;
  padding: calc(var(--cc_size_spacing_m) + 4px) var(--cc_size_spacing_xs);
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: var(--cc_size_border_width_m);
    background: var(--cc_color_link_primary);
    transition: all 0.25s ease-out;
    opacity: ${(props) => (props.active ? 1 : 0)};
    transform: scaleX(${(props) => (props.active ? '1' : '0.5')});
  }

  &:focus-visible {
    outline: var(--cc_size_border_width_m) solid var(--cc_color_link_primary);
  }

  &:hover {
    &::after {
      opacity: 1;
      transform: scaleX(1);
    }
  }
`;
// #endregion

const Tab = ({ label, activeTab, onClick, id }) => {
  const isSelected = activeTab === label;
  return (
    <StyledButton
      type="button"
      onClick={() => onClick(label)}
      active={isSelected}
      role="tab"
      aria-selected={isSelected}
      tabindex={isSelected ? 0 : -1}
      id={id}
    >
      {label}
    </StyledButton>
  );
};

Tab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default Tab;
